export class ApiUrl {
  /**
   * ApiUrl() gives the endpoint for the web api
   */
  public static webapiurl () {
    switch (window.location.host) {
      case 'cdp.wser.wur.nl':
        return 'https://cdp.wser.wur.nl/WebApi'
      case 'acc.cdp.wser.wur.nl':
        return 'https://acc.cdp.wser.wur.nl/WebApi'
      case 'tst.cdp.wser.wur.nl':
        return 'https://tst.cdp.wser.wur.nl/WebApi'
      default:
        return 'http://localhost:55910'
    }
  }

  public static getDataservicesUrl () {
    switch (window.location.host) {
      case 'cdp.wser.wur.nl':
        return 'https://dataservices.wser.wur.nl/'
      case 'acc.cdp.wser.wur.nl':
        return 'https://acc.dataservices.wser.wur.nl/'
      case 'tst.cdp.wser.wur.nl':
        return 'https://tst.dataservices.wser.wur.nl/'
      default:
        return 'https://tst.dataservices.wser.wur.nl/'
    }
  }
}
